import { Suspense, lazy, useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";
import { trackPageView, initContactTracking } from "@/lib/analytics";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import RegulatedIndustries from "@/pages/RegulatedIndustries";
const Admin = lazy(() => import("@/pages/Admin"));
const LegalPage = lazy(() => import("@/pages/LegalPage"));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    initContactTracking();
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView(pathname);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="flex-1">
          <Suspense fallback={<div className="py-40 text-center text-sm text-slate-400">Loading…</div>}>
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/regulated-industries" element={<RegulatedIndustries />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/privacy-policy" element={<LegalPage page="privacy-policy" />} />
            <Route path="/terms-of-use" element={<LegalPage page="terms-of-use" />} />
            <Route path="/cookie-policy" element={<LegalPage page="cookie-policy" />} />
            <Route path="/data-protection" element={<LegalPage page="data-protection" />} />
            <Route path="*" element={<Home />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
